import * as Actions from '../actions/storage.actions';

const initialState = {
	providers: [],
	selectedProvider: null,
	loading: false,
	error: null
};

const storageReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_STORAGE_PROVIDERS: {
			return {
				...state,
				providers: action.payload,
				error: null
			};
		}
		case Actions.SET_STORAGE_PROVIDER: {
			return {
				...state,
				selectedProvider: action.payload,
				error: null
			};
		}
		case Actions.SET_SELECTED_PROVIDER: {
			return {
				...state,
				selectedProvider: action.payload
			};
		}
		case Actions.SET_STORAGE_PROVIDERS_LOADING: {
			return {
				...state,
				loading: action.payload
			};
		}
		case Actions.SET_STORAGE_PROVIDERS_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.CLEAR_STORAGE_PROVIDERS: {
			return {
				...state,
				providers: [],
				selectedProvider: null,
				error: null
			};
		}
		case Actions.CLEAR_STORAGE_PROVIDERS_ERROR: {
			return {
				...state,
				error: null
			};
		}
		default: {
			return state;
		}
	}
};

export default storageReducer;
